<div class="breadcrumb-wrapper">
  @for (route of breadcrumbService.breadcrumbs; track $index; let last = $last) { @if (!last) {
  <a mat-button [routerLink]="route.url">
    {{ route.label | translate }}
  </a>

  <mat-icon>chevron_right</mat-icon>

  } @else {

  <span mat-button>
    {{ route.label | translate }}
  </span>
  } }
</div>
